import { DashboardShell } from "./DashboardShell";
import { MetricCard } from "./MetricCard";
import { ChartCard } from "./ChartCard";
import { ActivityPanel } from "./ActivityPanel";
import { retailPreview } from "@/data/dashboardPreview.data";

interface Props {
    accent: string;
}

export function RetailDashboard({
    accent,
}: Props) {
    const preview = retailPreview;

    return (
        <DashboardShell
            accent={accent}
            title="Retail Management System"
            subtitle="Sales, inventory and customer analytics"
            sidebar={[
                "Dashboard",
                "Sales",
                "Products",
                "Inventory",
                "Orders",
                "Customers",
                "Marketing",
                "Reports",
            ]}
        >
            <div className="grid gap-6">

                {/* =====================================================
                    Business KPIs
                ====================================================== */}

                <div className="grid gap-5 md:grid-cols-4">

                    {
                        preview.metrics.map((metric) => (

                            <MetricCard
                                key={metric.label}
                                accent={accent}
                                label={metric.label}
                                value={metric.value}
                                trend={metric.trend}
                            />

                        ))
                    }

                    {/* <MetricCard
                        accent={accent}
                        label="Today's Sales"
                        value="$48.6K"
                        trend="+18%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Orders"
                        value="1,284"
                        trend="+11%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Customers"
                        value="862"
                        trend="+9%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Conversion"
                        value="5.8%"
                        trend="+0.6%"
                    /> */}

                </div>

                {/* =====================================================
                    Revenue Analytics
                ====================================================== */}

                <div className="grid gap-6 lg:grid-cols-[2fr_1fr]">

                    <ChartCard
                        accent={accent}
                        title={preview.chart.title}
                        values={preview.chart.values}
                    />

                    <ActivityPanel
                        accent={accent}
                        title="Retail Activity"
                        items={preview.activities ?? []}
                    />

                </div>
                {/* =====================================================
                    Inventory Management
                ====================================================== */}

                {/* <div className="grid gap-6 lg:grid-cols-3">

                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Inventory Health
                        </h3>

                        <div className="mt-5 space-y-5">

                            {[
                                {
                                    category: "Electronics",
                                    value: 92,
                                },
                                {
                                    category: "Furniture",
                                    value: 84,
                                },
                                {
                                    category: "Fashion",
                                    value: 73,
                                },
                                {
                                    category: "Accessories",
                                    value: 95,
                                },
                            ].map((item) => (

                                <div key={item.category}>

                                    <div className="flex justify-between text-sm">

                                        <span>{item.category}</span>

                                        <span>{item.value}%</span>

                                    </div>

                                    <div className="mt-2 h-2 rounded-full bg-muted">

                                        <div
                                            className="h-full rounded-full"
                                            style={{
                                                width: `${item.value}%`,
                                                background: accent,
                                            }}
                                        />

                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Best Selling Products
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                "Wireless Headphones",
                                "Office Chair",
                                "Gaming Keyboard",
                                "Smart Watch",
                            ].map((product) => (

                                <div
                                    key={product}
                                    className="flex items-center justify-between rounded-xl border border-border px-4 py-3"
                                >

                                    <div>

                                        <p className="font-medium">
                                            {product}
                                        </p>

                                        <p className="text-xs text-muted-foreground">
                                            Top Performing SKU
                                        </p>

                                    </div>

                                    <span
                                        className="rounded-full px-3 py-1 text-xs font-semibold"
                                        style={{
                                            background: `${accent}15`,
                                            color: accent,
                                        }}
                                    >
                                        Top
                                    </span>

                                </div>

                            ))}

                        </div>

                    </div>
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            AI Demand Forecast
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                "Electronics demand expected to increase 22%.",
                                "Weekend sales forecast: +17%.",
                                "Recommend replenishing wireless accessories.",
                                "High demand expected for premium office chairs.",
                            ].map((forecast) => (

                                <div
                                    key={forecast}
                                    className="rounded-xl border border-border p-4"
                                >

                                    <p className="text-sm leading-relaxed">
                                        {forecast}
                                    </p>

                                </div>

                            ))}

                        </div>

                    </div>

                </div> */}
                {/* =====================================================
                    Retail KPIs
                ====================================================== */}

                {/* <div className="grid gap-5 md:grid-cols-4">

                    <MetricCard
                        accent={accent}
                        label="Customer Satisfaction"
                        value="97%"
                        trend="+4%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Repeat Customers"
                        value="68%"
                        trend="+5%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Average Basket"
                        value="$124"
                        trend="+7%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Stock Accuracy"
                        value="99.2%"
                        trend="+1%"
                    />

                </div> */}

            </div>

        </DashboardShell>

    );
}